// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1Fk4Y","alertIcon":"ConfirmModal_alertIcon__3uctF"};